'use strict'

import { createRouter, createWebHistory } from 'vue-router'
import multiguard from 'vue-router-multiguard'
import store from '../store'

import Users from '@/js/components/Users.vue'
import ErrorLogs from '@/js/components/ErrorLogs.vue'
import Login from '@/js/components/Login.vue'
import Logout from '@/js/components/Logout.vue'
import PasswordChangeRequest from '@/js/components/PasswordChangeRequest.vue'
import PasswordChange from '@/js/components/PasswordChange.vue'
import PasswordReset from '@/js/components/PasswordReset.vue'
import KennzahlenVerwaltungPage from '@/js/pages/KennzahlenVerwaltungPage.vue'
import Studiengaenge from '@/js/components/Studiengaenge.vue'
import ModulControl from '@/js/components/Modul/ModulControl.vue'
import UserView from '@/js/components/Benutzer/UserView.vue'
import ModulHandBuchControl from '@/js/components/ModulHandBuch/ModulHandBuchControl.vue'
import TooltipControl from '@/js/components/Tooltip/TooltipControl.vue'
import ModulhandbuchPage from '@/js/pages/ModulhandbuchPage.vue'
import DashboardPage from '@/js/pages/DashboardPage.vue'

const requiresAuth = function (to, from, next) {
    let isAuthenticated = store.getters['security/isAuthenticated']

    if (!isAuthenticated) {
        next({ name: 'Login' })
    } else if (to.name === 'Login' && isAuthenticated) {
        next({ name: 'ModulhandbuchPage' })
    } else {
        next()
    }
}

const requiresAdmin = function (to, from, next) {
    const isAdmin = store.getters['security/isAdmin']

    if (!isAdmin) {
        next({ name: 'Login' })
    } else {
        next()
    }
}

const requiresKennwerteAccess = function (to, from, next) {
    if (!store.getters['security/canViewKennwerte']) {
        next({ name: 'Login' })
    } else {
        next()
    }
}

let routes = [
    {
        id: 2,
        path: '/benutzer',
        component: Users,
        name: 'Users',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 21,
        path: '/benutzer/:userId',
        component: UserView,
        name: 'User',
        beforeEnter: multiguard([requiresAuth, requiresAdmin]),
        props: true
    },
    { id: 3, path: '/anmeldung', component: Login, name: 'Login' },
    {
        id: 4,
        path: '/studiengaenge',
        component: Studiengaenge,
        name: 'Studiengaenge',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 5,
        path: '/modulhandbuch-verwaltung',
        component: ModulHandBuchControl,
        name: 'ModulHandBuchControl',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 6,
        path: '/modul-verwaltung',
        component: ModulControl,
        name: 'ModulControl',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 7,
        path: '/kennzahlen-verwaltung',
        component: KennzahlenVerwaltungPage,
        name: 'KennzahlenVerwaltungPage',
        beforeEnter: multiguard([requiresAuth, requiresKennwerteAccess])
    },

    {
        id: 8,
        path: '/passwort-zuruecksetzen',
        component: PasswordReset,
        name: 'PasswordReset',
        props: true
    },
    { id: 9, path: '/abmeldung', component: Logout, name: 'Logout', beforeEnter: requiresAuth },
    {
        id: 10,
        path: '/passwort-aenderung-beantragen',
        component: PasswordChangeRequest,
        name: 'PasswordChangeRequest',
        beforeEnter: requiresAuth
    },
    {
        id: 11,
        path: '/passwort-aendern/:userId/:confirmationToken',
        component: PasswordChange,
        name: 'PasswordChange',
        props: true
    },
    {
        id: 13,
        path: '/modulhandbuecher',
        component: ModulhandbuchPage,
        name: 'ModulhandbuchPage',
        beforeEnter: requiresAuth
    },
    {
        id: 16,
        path: '/error-logs',
        component: ErrorLogs,
        name: 'ErrorLogs',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 17,
        path: '/tooltips',
        component: TooltipControl,
        name: 'TooltipControl',
        beforeEnter: multiguard([requiresAuth, requiresAdmin])
    },
    {
        id: 18,
        path: '/dashboard',
        component: DashboardPage,
        name: 'DashboardPage',
        beforeEnter: multiguard([requiresAuth, requiresKennwerteAccess])
    },
    {
        id: 19,
        path: '/:kuerzel/:semester',
        component: ModulhandbuchPage,
        name: 'ModulhandbuchBySemester',
        beforeEnter: requiresAuth,
        props: true
    },
    {
        id: 20,
        path: '/:kuerzel/:semester/:modulSlug',
        component: ModulhandbuchPage,
        name: 'ModulhandbuchModul',
        beforeEnter: requiresAuth,
        props: true
    },
    // {id: 90, path: "/impressum", component: Impressum, name: "Impressum"},
    // {id: 91, path: "/datenschutz", component: Datenschutz, name: "Datenschutz"},
    { id: 0, path: '/:pathMatch(.*)*', name: 'not-found', component: Login }
]

const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes // short for `routes: routes`
})

export default router
export { routes }
